// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum EstimateStatus {
  Active = 1,
  InActive = 2,
  Submitted = 3,
}
